import React from "react";
import { Modal, Button, Typography, Divider } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useAIAssessmentContext } from "../../../../Context/AIAssessmentContext/AIAssessmentContext";
import useAiAssessmentEvaluate from "../../hooks/useAiAssessmentEvaluate";
import "./modals.scss";

const RetryAiAssessmentModal: React.FC = () => {
  const { showRetryEvaluation, fullscreenElementRef, isFullscreen } =
    useAIAssessmentContext();

  const { handleEvaluation } = useAiAssessmentEvaluate();

  const handleRetryClick = async () => {
    await handleEvaluation("user");
  };
  return (
    <Modal
      closeIcon={false}
      destroyOnClose={true}
      centered
      keyboard={false}
      open={showRetryEvaluation}
      // onCancel={handleClose}
      maskClosable={false}
      footer={null}
      getContainer={
        isFullscreen ? () => fullscreenElementRef.current! : undefined
      }
    >
      <div className="modal-content">
        <div className="modal-content-header">
          <Typography.Title level={5} style={{ margin: 0 }}>
            Evaluation Failed
          </Typography.Title>
        </div>
        <Divider style={{ margin: 0 }} />
        <div className="violation-modal-content-icon">
          <CloseOutlined />
        </div>

        <Typography.Text>
          Evaluation failed. Please retry the evaluation again.
        </Typography.Text>
      </div>
      <div className="ai-assessment-modal-footer">
        <Button type="primary" onClick={handleRetryClick}>
          Retry Evaluation
        </Button>
      </div>
    </Modal>
  );
};

export default RetryAiAssessmentModal;
